import { isLightshop, isNordicNest, isSvenssons } from 'webapp/theme';

export const BANNER_MOBILE_HEIGHT = 24;

export const BANNER_DESKTOP_HEIGHT = isSvenssons ? 32 : 30;

export const HEADER_HEIGHT = 64;
export const DESKTOP_HEADER_WITHOUT_MENU = 66;

export const SEARCH_FIELD_HEIGHT = isSvenssons ? 34 : 42;

export const HEADER_HEIGHT_WITH_SEARCH = HEADER_HEIGHT + SEARCH_FIELD_HEIGHT;

export const DESKTOP_HEADER_HEIGHT =
  isSvenssons || isNordicNest ? DESKTOP_HEADER_WITHOUT_MENU + 44 : DESKTOP_HEADER_WITHOUT_MENU + 43;

export const DESKTOP_HEADER_HEIGHT_WITH_BANNER = DESKTOP_HEADER_HEIGHT + BANNER_DESKTOP_HEIGHT;

export const CENTER_TOP_MENU = isSvenssons || isLightshop;
